import { STATUSES } from '@/constants';
import { ReturnedProduct as ReturnedProductOrder } from '@/models/order';
import { getLowestPrice } from '@/utils/commerce';
import { currency } from '@/utils/i18n';

// This class is for creating a new Return, not normalizing an existing Return;
// An existing ReturnedProduct has different fields and data shape, which match ReturnedProduct
export default class ReturnedProduct implements ReturnedProductOrder {
  public allowFractionalQuantities;
  public availableToReturn;
  public displayName;
  public id;
  public soldByCase;
  public price;
  public product;
  public quantity;
  public refundAmount;
  public returnReason;
  public shouldRestock;
  public sku;
  public unitDenomination;
  public unitOfMeasure;

  constructor(data) {
    const hasExistingOrder = Boolean(data.orderId); // is this product from an existing order

    this.allowFractionalQuantities = data.allowFractionalQuantities;
    // the quantity of product that's available for return; "unlimited" (Infinity) for products that aren't tied to any order
    this.availableToReturn = hasExistingOrder ? parseFloat(data.quantityWhenOrdered) || 0 : Infinity;
    this.displayName = data.displayName;
    this.product = data.product || data.id;
    this.soldByCase = data.unitMultiplier > 1 || data.soldByCase;
    // prepopulate the price field with the original order's pricing, otherwise leave it blank
    this.price = {
      amount:
        data.price?.amount ||
        (hasExistingOrder ? getLowestPrice(data.orderedUnitPrice.amount, data.salePrice.amount) : ''),
      currency: currency.default,
    };
    this.quantity = data.quantity;
    this.refundAmount = {
      amount: data.refundAmount?.amount ?? '',
      currency: currency.default,
    };
    this.returnReason = data.returnReason;
    this.shouldRestock = data.shouldRestock || false;
    this.sku = data.sku;
    this.unitDenomination = data.unitDenomination;
    this.unitOfMeasure = data.unitOfMeasure;

    if (
      !this.unitDenomination &&
      data.frozenData?.product.unitDenomination !== STATUSES.PRODUCT_UNIT_DENOMINATION.ONE.label
    ) {
      this.unitDenomination = {
        label: data.frozenData.product.unitDenomination,
      };
    }
  }
}
